import { apiClient } from '@/shared/api';
import type { ShopSettings } from './components';

interface APIKeyResponse {
  apiKey: string;
}

export const settingsApi = {
  getSettings: () =>
    apiClient.get<ShopSettings>('/settings'),

  updateSettings: (settings: ShopSettings) =>
    apiClient.put<ShopSettings>('/settings', settings),

  getAPIKey: () =>
    apiClient.get<APIKeyResponse>('/settings/api-key'),

  rotateAPIKey: () =>
    apiClient.post<APIKeyResponse>('/settings/api-key/rotate'),
};
